import axios from 'axios'

let _svc
let _that

export default {
  CheckIfLoggedIn: () => {
    try {
      return _svc.get('Authentication/Public/Login/Check')
    } catch {
      return null
    }
  },
  Init: (that) => {
    _that = that

    _svc = axios.create({
      baseURL: process.env.VUE_APP_API_URL
    })

    _svc.interceptors.response.use(
      response => response,
      error => {
        _that.ErrorMixin_HandleError(error)
      }
    )
  },
  Login: (account) => {
    try {
      return _svc.put('Authentication/Public/Login', account)
    } catch {
      return null
    }
  }
}
